export function detectUserRegion(): string {
  return 'Europe'
}
